
import { defineComponent } from "vue";
//import BrwrHeaderView from "./BrwrHeaderView.vue";
import BrwrHeaderView from "./BrwrHeaderMobileView.vue";
import BrwrFooterView from "./BrwrFooterView.vue";

export default defineComponent({
  name: "BrwrLayout",
  components: {
  //  BrwrHeaderView,
    BrwrHeaderView,
    BrwrFooterView
  },
});
